// import { Box, useMediaQuery, useTheme } from '@material-ui/core';
import { Box } from '@material-ui/core';
import moment from 'moment/moment';
import React from 'react';

import { useResponsiveFlags } from '../../../shared/lib';

import { ArrowButton } from './arrowButton';
import { SimpleButton } from './simpleButton';

export const CalendarWidget = ({
  date,
  onChangeDate,
  hideTodayButton = false,
}: {
  date: number;
  onChangeDate: (date: moment.Moment) => void;
  hideTodayButton?: boolean;
}) => {
  const { isLargeScreen } = useResponsiveFlags();
  const isSmallScreen = !isLargeScreen && !hideTodayButton;
  const today = moment().startOf('day');
  const d = moment(date);
  let weekday = d.format('dd');
  weekday = weekday.charAt(0).toUpperCase() + weekday.slice(1);
  const isToday = d.isSame(today, 'day');
  const prevDate = d.clone().subtract(1, 'day').startOf('day');

  return (
    <Box display="flex" flexDirection="row" alignItems="center">
      <Box flexGrow={0} style={{ marginRight: 4 }}>
        <ArrowButton
          variant="left"
          onClick={() => onChangeDate(prevDate)}
          disabled={prevDate.isBefore(today)}
        />
      </Box>
      <Box
        flexGrow={1}
        style={{
          marginRight: 4,
          marginLeft: 4,
          fontSize: isSmallScreen ? 13 : 16,
          fontWeight: 500,
          color: '#181F28',
          lineHeight: 1,
          textAlign: 'center',
          minWidth: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {weekday}
        {', '}
        <span style={{ whiteSpace: 'nowrap' }}>{d.format(isSmallScreen ? 'D MMM' : 'D MMMM')}</span>
      </Box>
      <Box flexGrow={0} style={{ marginRight: 4, marginLeft: 4 }}>
        <ArrowButton
          variant="right"
          onClick={() => {
            onChangeDate(d.clone().add(1, 'day').startOf('day'));
          }}
        />
      </Box>
      {!hideTodayButton && (
        <Box flexGrow={0}>
          <SimpleButton onClick={() => onChangeDate(null)} label="Сегодня" active={isToday} />
        </Box>
      )}
    </Box>
  );
};
